import { RSAA } from "redux-api-middleware";
import { ICustomerDetails } from "./Model";
import { getDefaultHeaders, getSettings } from "../Settings";
import {  IRouteLeg } from "../Models";
import dayjs from "dayjs";

export type SkinetworksActionType = "setCustomerDetails" | "clearCustomerDetails" | "clearAvailableTimes" |
"bookTableStarted" | "bookTableComplete" | "bookTableFailed";

export const setCustomerDetails = (customerDetails: ICustomerDetails) =>  ({ type: "setCustomerDetails", customerDetails });
export const clearCustomerDetails = () => ({ type: "clearCustomerDetails"});
export const clearAvailableTimes = () => ({ type: "clearAvailableTimes" });

export const bookTable = (leg: IRouteLeg, persons: number, time: string, date: dayjs.Dayjs, customer: ICustomerDetails, menuOptions: string[], travelId: string, slot: "lunch"|"dinner") => {
	const payload = {
		serviceName: leg.serviceName,
		persons,
		time,
		date: date.format("YYYY-MM-DD"),
		customer,
		menuOptions
	};

	const meta = { travelId, slot };

	return {
		type: "bookTable",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/skinetworks/book`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ meta, type: "bookTableStarted" },
				{ meta, type: "bookTableComplete" },
				{ meta, type: "bookTableFailed" }
			]
		}
	};
};